import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DartboardTableService } from '../../table-data.service';

@Component({
  selector: 'app-table-job-totals',
  templateUrl: './totals.component.html',
  styleUrls: ['./totals.component.scss']
})
export class TotalsComponent implements OnChanges {
  
  @Input() jobs: any[];
  @Input() numberSold: number;
  @Input() numberLost: number;
  @Input() numberPending: number;
  @Input() soldJobs: any[];
  totalSales: number;
  constructor(
    public dartboardTableService: DartboardTableService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.totalSales = this.getJobsTotal()
  }

   getJobsTotal() {
    const processedGroups = new Set();
    const total = this.soldJobs.reduce((total, job) => {
      if (!job?.confirmation) {
        return total;
      }

      const { jobsGroupId } = job?.meta || {};
      if (jobsGroupId && processedGroups.has(jobsGroupId)) {
        return total; // Skip if group already processed
      }

      if (job?.confirmation?.prices?.total) {
        total += job?.confirmation?.prices?.total;
        processedGroups.add(jobsGroupId); // Mark group as processed
      }

      return total;
    }, 0);
    return total;
  }


}
